// extracted by mini-css-extract-plugin
module.exports = {"viewLink":"viewLink-module--viewLink--J6Bje","link":"viewLink-module--link--3EvA1"};